export default "__VITE_ASSET__10c6db54__"